import { rgba } from 'polished'

import theme from 'styles/theme'
import { Variant } from './Pill'

export const OwnerPillVariant: Variant = {
  kind: 'special',
  textTint: theme.colors.brand.teal[50],
  backgroundTint: rgba(theme.colors.brand.teal[100], 0.3),
}

export const AdminPillVariant: Variant = {
  kind: 'special',
  textTint: theme.colors.brand.purple[50],
  backgroundTint: rgba(theme.colors.brand.purple[100], 0.3),
}

export const FinancePillVariant: Variant = {
  kind: 'special',
  textTint: theme.colors.brand.green[50],
  backgroundTint: rgba(theme.colors.brand.green[100], 0.3),
}
